export default "__VITE_ASSET__Xy2hOIcP__"